import { render, staticRenderFns } from "./PowerBIPanel.vue?vue&type=template&id=4a1c8bd0"
import script from "./PowerBIPanel.vue?vue&type=script&lang=js"
export * from "./PowerBIPanel.vue?vue&type=script&lang=js"
import style0 from "./PowerBIPanel.vue?vue&type=style&index=0&id=4a1c8bd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports